import i18n from '../i18n';
import { formatDate, formatTime } from './formatDate';

/**
 * Umgang mit Geburtsdatum + Geburtszeit.
 *
 * Bei Welpen ist die Uhrzeit relevant (Reihenfolge der Geburt), bei erwachsenen
 * Hunden meist nicht. Beide Faelle liegen im selben DateTime-Feld, deshalb gilt:
 * lokale Mitternacht bedeutet "keine Uhrzeit erfasst".
 */

/**
 * Baut aus Datum (yyyy-mm-dd) und optionaler Uhrzeit (hh:mm) den Zeitstempel fuer das Backend.
 *
 * WICHTIG: bewusst OHNE Zeitzonen-Suffix und ohne Umrechnung nach UTC.
 * Das Backend speichert DateTime ohne Offset und liefert ihn auch so wieder aus
 * ("2026-08-10T13:45:00"). Wuerde hier nach UTC umgerechnet (toISOString), kaeme die
 * Uhrzeit beim Zurueckladen um den Zeitzonen-Offset verschoben an - aus 13:45 wuerde 11:45.
 * Gespeichert wird daher die Wanduhrzeit, konsistent zu allen anderen Daten der App.
 */
export const buildBirthTimestamp = (date: string, time: string): string | null => {
  if (!date) return null;
  return `${date}T${time || '00:00'}:00`;
};

/** Liefert die Uhrzeit, oder null wenn keine erfasst wurde (lokale Mitternacht). */
export const formatBirthTime = (value: string | null): string | null => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  if (d.getHours() === 0 && d.getMinutes() === 0) return null;
  return formatTime(d);
};

/** Datum, bei erfasster Uhrzeit ergaenzt um die lokalisierte Uhrzeitangabe (z.B. "um HH:MM Uhr"). */
export const formatBirthDateTime = (value: string | null): string => {
  if (!value) return '—';
  const date = formatDate(value);
  const time = formatBirthTime(value);
  return time ? i18n.t('common:dateTime.atTime', { date, time }) : date;
};
